import styles from '../styles/PatientCard.module.scss';
import React, {useState} from "react";
import Button from "./Button";
import { useSound } from '../context/SoundContext';
const base = process.env.PUBLIC_URL || ``;

interface PatientCardProps {
    pages: string[];
    onAnalyzesClick: () => void;
    onCloseClick: () => void;
}

const PatientCard: React.FC<PatientCardProps> = ({ pages, onAnalyzesClick, onCloseClick }) =>  {
    const [page, setPage] = useState(0);
    // @ts-ignore
    const { muted, toggleMuted } = useSound();

    const handlePrevClick = () => {
        if (page === 0){
            setPage(pages.length - 1)
        }else {
            setPage(page - 1)
        }
    }
    const handleNextClick = () => {
        if (page === pages.length - 1){
            setPage(0)
        }else {
            setPage(page + 1)
        }
    }


    return (
        <div className={styles.PatientCard}>
            {!muted &&
                <>
                    <audio src={`${base}/audio/click.mp3`} autoPlay={true} playsInline={true}></audio>
                    <audio src={`${base}/audio/card.mp3`} autoPlay={true} playsInline={true}></audio>
                </>
            }
            <div className={styles.PatientCardPages}>
                <img src={pages[page]} className={styles.cardPage} alt="Step" />
                <div className={styles.prevPage} onClick={handlePrevClick}></div>
                <div className={styles.nextPage} onClick={handleNextClick}></div>
                <div className={styles.closeCard} onClick={onCloseClick}></div>
            </div>
            <img src={`${base}/images/view_info_btn.png`} onClick={onAnalyzesClick} className={styles.viewInfoBtn} alt="view_info_btn" />

        </div>
    );
}


export default PatientCard;
